import map from 'lodash/map';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import {
  GET_APPENDED_RESULTS,
  RESET_GET_APPENDED_RESULTS,
} from '../constants/ActionTypes';
import omit from 'lodash/omit';

interface SearchResult {
  items: any[];
  total: number;
  error?: any;
  loading?: boolean;
  loaded?: boolean;
}

export interface GetAppendedResultsQueryInitialState {
  items: any[];
  total: number;
  error: any;
  loading: boolean;
  loaded: boolean;
  subrequests: {
    [key: string]: SearchResult;
  };
}

interface GetAppendedResultsQueryInitialAction {
  type: string;
  subrequest: string;
  result?: { items: any[]; items_total: number };
  error?: string;
  appendResults: boolean;
}

const getAppendedResultsQueryInitialState: GetAppendedResultsQueryInitialState =
  {
    error: null,
    items: [],
    total: 0,
    loaded: false,
    loading: false,
    subrequests: {},
  };

export const getAppendedResultsQuery = (
  state = getAppendedResultsQueryInitialState,
  action: GetAppendedResultsQueryInitialAction,
): GetAppendedResultsQueryInitialState => {
  switch (action.type) {
    case `${GET_APPENDED_RESULTS}_PENDING`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...(state.subrequests[action.subrequest] || {
                  items: [],
                  total: 0,
                }),
                error: null,
                loaded: false,
                loading: true,
              },
            },
          }
        : {
            ...state,
            error: null,
            loading: true,
            loaded: false,
          };
    case `${GET_APPENDED_RESULTS}_SUCCESS`:
      const newItems = map(action.result.items, (item) => ({
        ...item,
        '@id': flattenToAppURL(item['@id']),
      }));
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: null,
                items: action.appendResults
                  ? [
                      ...(state.subrequests?.[action.subrequest]?.items || []),
                      ...newItems,
                    ]
                  : newItems,
                total: action.result.items_total,
                loaded: true,
                loading: false,
              },
            },
          }
        : {
            ...state,
            error: null,
            items: action.appendResults
              ? [...(state.items || []), ...newItems]
              : newItems,
            total: action.result.items_total,
            loaded: true,
            loading: false,
          };

    case `${GET_APPENDED_RESULTS}_FAIL`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: action.error,
                items: [],
                total: 0,
                loading: false,
                loaded: false,
              },
            },
          }
        : {
            ...state,
            error: action.error,
            items: [],
            total: 0,
            loading: false,
            loaded: false,
          };

    case RESET_GET_APPENDED_RESULTS:
      return action.subrequest
        ? {
            ...state,
            subrequests: omit(state.subrequests, [action.subrequest]),
          }
        : {
            ...state,
            error: null,
            items: [],
            total: 0,
            loading: false,
            loaded: false,
          };

    default:
      return state;
  }
};
